// src/merch/LogoPicker.jsx
//
// Team logo library: search, tap a logo, it lands on the current sticker.

import React, { useMemo, useState } from "react";
import { LOGO_GROUPS, logoUrl } from "./logos";
import { addLayerRaw } from "./store";

function initials(name) {
  return name.split(/[\s-]+/).filter((w) => /^[A-Z]/.test(w)).slice(0, 3).map((w) => w[0]).join("");
}

export default function LogoPicker({ area, onClose }) {
  const [q, setQ] = useState("");
  const groups = useMemo(() => {
    const t = q.trim().toLowerCase();
    return LOGO_GROUPS.map((g) => ({
      ...g,
      logos: g.logos.filter((l) => !t || l.name.toLowerCase().includes(t)),
    })).filter((g) => g.logos.length);
  }, [q]);

  function add(logo) {
    const url = logoUrl(logo);
    if (!url) return;
    // start at ~80% of the sticker's short side, centred
    const aw = area.x1 - area.x0, ah = area.y1 - area.y0;
    addLayerRaw({
      name: logo.name,
      url,
      kind: "logo", // pre-approved library logo (not flagged like uploads)
      transform: { tx: (area.x0 + area.x1) / 2, ty: (area.y0 + area.y1) / 2, scale: Math.min(aw, ah) * 0.8, rot: 0 },
    });
    onClose();
  }

  return (
    <div className="ma-modal" onPointerDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="ma-modal-card ma-logos" role="dialog" aria-label="Team logos">
        <div className="ma-modal-head">
          <b>Team logos</b>
          <button className="ma-btn ghost" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <input className="ma-input ma-logo-search" placeholder="Search teams…" value={q} onChange={(e) => setQ(e.target.value)} />
        {groups.map((g) => (
          <div key={g.id}>
            <h3>{g.label}</h3>
            <div className="ma-logo-grid">
              {g.logos.map((l) => {
                const url = logoUrl(l);
                return (
                  <button key={l.id} className="ma-logo-item" disabled={!url} onClick={() => add(l)} title={url ? l.name : `${l.name} — coming soon`}>
                    {url ? <img src={url} alt="" /> : <span className="ma-logo-ph">{initials(l.name)}</span>}
                    <span className="ma-logo-name">{l.name}</span>
                    {!url && <span className="ma-logo-soon">coming soon</span>}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
        {!groups.length && <p className="ma-muted">No teams match “{q}”.</p>}
        <p className="ma-muted">Only official, approved logos are available here. Other team or league logos can't be printed.</p>
      </div>
    </div>
  );
}
